export class HeaderDispute {
    channelCode: string;
    commitmentDate: string;
    commitmentDateObj: Date;
    countryCode: string;
    customerCode: string;
    customerDesc: string;
    dateOfLastChange: string;
    dateOfLastChangeObj: Date;
    disputeCategoryCode: string;
    disputeCategoryDesc: string;
    disputeCode: string;
    disputeDate: string;
    disputeDateObj: Date;
    disputeId: number;
    disputeStatusCode: string;
    disputeStatusDesc: string;
    divisionCode: string;
    jobSiteCode: string;
    jobSiteDesc: string;
    regionOfJobSite: string;
    salesAreaCode: string;
    salesOrgCode: string;
    sectorCode: string;
    segment: string;
}

export class InvoiceDisputed {
    amount: any;
    balance: any;
    compromiseDate: string;
    compromiseDateObj: Date;
    disputeStatusCode: string;
    disputeStatusDesc: string;
    documentCode: string;
    documentId: string;
    dueDate: string;
    dueDateObj: Date;
    jobSiteCode: string;
    jobSiteDesc: string;
}

export class Email {
    contactEmail?: string;
}
export interface DisputeDetail {
    compromiseDate: string;
    managerName: string;
    salesRepName: string;
    salesOfficeCode: string;
    invoicesDisputed: Array<InvoiceDisputed>;
    additionalContactEmails: Array<Email>;
    // optional
    headerDispute?: HeaderDispute;
    compromiseDateObj?: Date;
    directorCode?: string;
    directorName?: string;
    directorEmail?: string;
    managerCode?: string;
    managerEmail?: string;
    salesRepCode?: string;
    salesRepEmail?: string;
    responsibleCode?: string;
    responsibleName?: string;
    responsibleEmail?: string;
}
